import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotifyChangeDetectionService {
  private readonly requestChangeDetection$ = new Subject<void>();

  public notify(): void {
    this.requestChangeDetection$.next();
  }

  public getSubject(): Subject<void> {
    return this.requestChangeDetection$;
  }
}
